import React from 'react';
import Navbar from './Navbar';

const Layout = ({ children }) => {
  return (
    <div className="dark min-h-screen bg-dark-950 text-white selection:bg-primary-500/30 selection:text-primary-200">
      {/* Background Effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
        <div className="absolute -top-[10%] -left-[10%] w-[40%] h-[40%] bg-primary-900/10 rounded-full blur-[120px] animate-pulse-slow"></div>
        <div className="absolute top-[20%] -right-[5%] w-[30%] h-[30%] bg-secondary-900/10 rounded-full blur-[100px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="print:hidden">
        <Navbar />
      </div>
      
      <main className="relative pt-32 pb-20 px-4 max-w-screen-lg mx-auto print:pt-0 print:pb-0 print:px-0 print:max-w-none print:m-0">
        {children}
      </main>

      <footer className="py-12 px-4 border-t border-white/5 print:hidden">
        <div className="max-w-screen-lg mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-white/40 text-sm">
            © {new Date().getFullYear()} Samir Djelal. All rights reserved.
          </div>
          <div className="flex gap-6">
            <a href="https://github.com/samirdjelal" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors">Github</a>
            <a href="https://www.linkedin.com/in/samirdjelal" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors">LinkedIn</a>
            <a href="https://twitter.com/samirdjelal" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors">Twitter</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
